module.exports = "<div class=c-tablist__content-wrapper :id=\"'tablist-' + name\"> <div role=tabpanel v-if=open class=c-tablist__tab :aria-labelledby=\"'tab-' + name\" :class=\"{ 'c-tablist__tab--active' : open }\"> <slot></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/archive/templates/tab-content.html
// module id = 157
// module chunks = 0